import c from './Landing.module.css';
import { TOOLKIT } from './data';

export function Toolkit() {
  return (
    <section id="toolkit" className={c.toolkit}>
      <div className={`${c.container} ${c.toolkitInner}`}>
        <div>
          <div className={c.eyebrow}>03 — TOOLKIT</div>
          <h2 className={c.h2sm}>Every layer of the AI stack</h2>
          <p className={c.toolkitBlurb}>Twelve disciplines we bring to client engagements.</p>
        </div>
        <div className={c.toolGrid}>
          {TOOLKIT.map((t) => (
            <div key={t} className={c.tool}><span className={c.toolDot} />{t}</div>
          ))}
        </div>
      </div>
    </section>
  );
}
